import React, { useEffect } from 'react';

// === DATOS DE PRODUCCIÓN ===
const PROJECT_ID = 'ZN_aW577ZWwfD7ECNb';
const BRAND_ID = 'aeromex';
const INTERCEPT_ID = 'SI_3Ez4gG3940Uu8HW'; // Documentado como referencia, Qualtrics lo lee internamente.

// Qualtrics requiere que el div contenedor tenga el Project ID
const PLACEHOLDER_ID = PROJECT_ID;

// Construimos el subdominio dinámicamente (znaw577zwwfd7ecnb-aeromex)
const SUBDOMAIN = `${PROJECT_ID.replace('_', '').toLowerCase()}-${BRAND_ID}`;

// Generamos la URL del script solo con el Project ID (Q_ZID) para evitar el error del servidor
const QUALTRICS_SRC = `https://${SUBDOMAIN}.siteintercept.qualtrics.com/SIE/?Q_ZID=${PROJECT_ID}`;

const QualtricsFeedback = () => {
  useEffect(() => {
    let script;
    let createdPlaceholder = false;

    // Aseguramos que el placeholder exista directamente en el <body>
    let placeholder = document.getElementById(PLACEHOLDER_ID);
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.id = PLACEHOLDER_ID;
      document.body.appendChild(placeholder);
      createdPlaceholder = true;
      console.info('Qualtrics: created placeholder div on body');
    }

    // Creamos e inyectamos el script
    script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = QUALTRICS_SRC;
    script.async = true;

    script.onload = () => console.info('Qualtrics script loaded:', QUALTRICS_SRC);
    script.onerror = (e) => console.error('Qualtrics script failed to load:', e, QUALTRICS_SRC);

    document.body && document.body.appendChild(script);

    // Inyectamos CSS para asegurar que el interceptor sea visible sobre la UI
    const css = `#${PLACEHOLDER_ID} { position: fixed !important; bottom: 16px !important; right: 16px !important; z-index: 2147483647 !important; pointer-events: auto !important; } #${PLACEHOLDER_ID} * { z-index: 2147483647 !important; }`;
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head && document.head.appendChild(style);

    // Log para ayudar en debugging
    const debugTimer = setTimeout(() => {
      const p = document.getElementById(PLACEHOLDER_ID);
      console.info('Qualtrics placeholder element:', p);
      try {
        console.info('Qualtrics placeholder innerHTML length:', p && p.innerHTML ? p.innerHTML.length : 0);
      } catch (e) {
        console.warn('Cannot read innerHTML of placeholder', e);
      }
    }, 1200);

    // Limpieza al desmontar el componente
    return () => {
      try {
        clearTimeout(debugTimer);
        if (script && script.parentNode) script.parentNode.removeChild(script);
        if (style && style.parentNode) style.parentNode.removeChild(style);
        if (createdPlaceholder) {
          const el = document.getElementById(PLACEHOLDER_ID);
          el && el.parentNode && el.parentNode.removeChild(el);
        }
      } catch (e) {
        // ignore
      }
    };
  }, []);

  return <></>;
};

export default QualtricsFeedback;